var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-tel-input',{class:_vm.clas,attrs:{"placeholder":_vm.$t('Phone'),"value":_vm.value,"default-country":_vm.defaultCountry,"preferred-countries":_vm.preferredCountries},on:{"input":_vm.checkPhone}})}
var staticRenderFns = []

export { render, staticRenderFns }